import type { IEmServiceDetails } from '@emarketer/auth/types';
import { SERVICE_TIER_FREEMIUM, SERVICE_TIER_PRO, SERVICE_TIER_PUBLIC } from '@emarketer/auth/constants';

interface IAuthConfigParams {
  publicForecastsServiceUrl: string;
  loggedInForecastsServiceUrl: string;
  currentEnvironment: any;
}

/**
 * Returns the authentication configuration with tier-to-route mappings.
 * In short: this tells the Common.Auth.Web package where to route what type of user.
 * It also tells which service is currently active (via. `isOnNow:true` prop).
 * @returns {IEmServiceDetails} The authentication configuration object
 */
export function GetAuthConfig(iAuthConfig: IAuthConfigParams): IEmServiceDetails {
  return {
    tierToRouteMapping: [
      {
        tiers: [SERVICE_TIER_PUBLIC],
        route: iAuthConfig.publicForecastsServiceUrl,
        isOnNow: true,
      },
      {
        tiers: [SERVICE_TIER_PRO, SERVICE_TIER_FREEMIUM], // as of 2025, both PRO & FREEMIUM are on the same na1 pod
        route: iAuthConfig.loggedInForecastsServiceUrl,
        isOnNow: false,
      },
    ],
    currentEnvironment: iAuthConfig.currentEnvironment,
  };
}
